/**
 * Найти в списке события, чей диапазон дат покрывает день календаря.
 * Чистый хелпер — без DOM, без Vue.
 *
 * @param {Array<{ date_start: string, date_finish?: string|null }>} eventsList
 * @param {Date} normalizedDate дата в локальную полночь
 * @param {(isoDate: string) => Date} parseIsoDate
 * @returns {{
 *   matchingEvents: Array,
 *   firstIndex: number,
 *   lastIndex: number,
 * }}
 */
export function findEventsOnDateInList(eventsList, normalizedDate, parseIsoDate) {
  const matchingEvents = [];
  const matchingIndexes = [];
  const safeList = eventsList || [];

  safeList.forEach((event, index) => {
    const rangeStart = parseIsoDate(event.date_start);
    rangeStart.setHours(0, 0, 0, 0);

    const rangeFinish = event.date_finish
      ? parseIsoDate(event.date_finish)
      : new Date(rangeStart);
    rangeFinish.setHours(0, 0, 0, 0);

    if (normalizedDate >= rangeStart && normalizedDate <= rangeFinish) {
      matchingEvents.push(event);
      matchingIndexes.push(index);
    }
  });

  if (matchingIndexes.length === 0) {
    return {
      matchingEvents: [],
      firstIndex: -1,
      lastIndex: -1,
    };
  }

  return {
    matchingEvents,
    firstIndex: matchingIndexes[0],
    lastIndex: matchingIndexes[matchingIndexes.length - 1],
  };
}
